import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/utils";
import type { CommunicationAudience } from "./communications-types";

const VARIANT_CLASS: Record<CommunicationAudience, string> = {
  USER: "bg-wander-gray/15 text-wander-black ring-wander-gray/40",
  ADMIN: "bg-wander-black/90 text-white ring-wander-black",
};

interface AudienceBadgeProps {
  readonly audience: CommunicationAudience;
  readonly className?: string;
}

export function AudienceBadge({ audience, className }: AudienceBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={`communications-audience-${audience.toLowerCase()}`}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset",
        VARIANT_CLASS[audience],
        className,
      )}
    >
      {t(`communications.audience.${audience}`)}
    </span>
  );
}
